import { render } from "./post-collapse.vue?vue&type=template&id=77b8662c&scoped=true"
import script from "./post-collapse.vue?vue&type=script&lang=js"
export * from "./post-collapse.vue?vue&type=script&lang=js"

import "./post-collapse.vue?vue&type=style&index=0&id=77b8662c&scoped=true&lang=css"
import "./post-collapse.vue?vue&type=style&index=1&id=77b8662c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b8662c"]])

export default __exports__